import React from 'react'
import {Link} from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import { scrollToTop } from '../header';
import { getCurrentBrand } from '../../config/brands'; // Import the brand utility
import './style.css'

const PageTitle = (props) => {
    const { t } = useTranslation();
    const currentBrand = getCurrentBrand(); // Get the current brand

    // Define the inline style for the background image using the path from brand config
    const sectionStyle = {
        backgroundImage: `url(${currentBrand.assets.background})`, // Use the background path from assets
        backgroundSize: 'cover', // Ensure the image covers the container
        backgroundPosition: 'center center', // Center the image
        backgroundRepeat: 'no-repeat' // Prevent tiling
    };

    return(
        <section className="page-title" style={sectionStyle}> {/* Apply the inline style */}
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <h1>{props.pageTitle}</h1>
                        <ol className="breadcrumb">
                            <li><Link onClick={() => scrollToTop()} to="/home">{t('navigation.home')}</Link></li>
                            <li><span>{props.pagesub}</span></li>
                        </ol>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default PageTitle;